import { render } from "./StaffForm.vue?vue&type=template&id=a3534e5e&scoped=true"
import script from "./StaffForm.vue?vue&type=script&lang=js"
export * from "./StaffForm.vue?vue&type=script&lang=js"

import "./StaffForm.vue?vue&type=style&index=0&id=a3534e5e&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3534e5e"]])

export default __exports__